import * as React from 'react';
import {Facebook, Github, Instagram, Linkedin, Twitter} from 'lucide-react';
import BrandLogo from './BrandLogo';
import {BRAND} from '../brand';

const SOCIAL_ICONS = {instagram: Instagram, twitter: Twitter, linkedin: Linkedin, github: Github, facebook: Facebook} as const;

const Footer: React.FC = () => {
    return (
        <footer className="bg-black border-t border-gray-900 pt-16 pb-8">
            <div className="max-w-7xl mx-auto px-6">
                <div className="grid grid-cols-1 md:grid-cols-4 gap-12 mb-16">
                    <div className="col-span-1 md:col-span-2">
                        <div className="flex items-center gap-2 mb-6">
                            <BrandLogo className="w-6 h-6 text-lumina-accent"/>
                            <span className="text-xl font-display font-bold tracking-widest text-white">
                {BRAND.wordmark}
              </span>
                        </div>
                        <p className="text-gray-500 max-w-sm mb-6">
                            {BRAND.footer.blurb}
                        </p>
                        <div className="flex gap-4">
                            {(Object.keys(SOCIAL_ICONS) as (keyof typeof SOCIAL_ICONS)[])
                                .filter((network) => BRAND.social?.[network])
                                .map((network) => {
                                    const Icon = SOCIAL_ICONS[network];
                                    return (
                                        <a key={network} href={BRAND.social[network]} aria-label={network}
                                           className="text-gray-500 hover:text-white transition-colors">
                                            <Icon className="w-5 h-5"/>
                                        </a>
                                    );
                                })}
                        </div>
                    </div>

                    <div>
                        <h4 className="text-white font-bold uppercase tracking-wider mb-6">Services</h4>
                        <ul className="space-y-4 text-gray-500 text-sm">
                            {BRAND.footer.services.map((name) => (
                                <li key={name}><a href="/#services" className="hover:text-lumina-accent transition-colors">{name}</a></li>
                            ))}
                            {BRAND.gallery && (
                                <li><a href={BRAND.gallery.url} className="hover:text-lumina-accent transition-colors">Photo Gallery</a></li>
                            )}
                        </ul>
                    </div>

                    <div>
                        <h4 className="text-white font-bold uppercase tracking-wider mb-6">Legal</h4>
                        <ul className="space-y-4 text-gray-500 text-sm">
                            <li><a href="/privacy" className="hover:text-lumina-accent transition-colors">Privacy Policy</a>
                            </li>
                            <li><a href="/data-deletion" className="hover:text-lumina-accent transition-colors">Data Deletion</a>
                            </li>
                            <li><a href="/terms" className="hover:text-lumina-accent transition-colors">Terms of Service</a>
                            </li>
                            <li><a href="/terms#rentals" className="hover:text-lumina-accent transition-colors">Terms of Rental</a>
                            </li>
                            <li><a href="#" className="hover:text-lumina-accent transition-colors">Insurance
                                Requirements</a></li>
                        </ul>
                    </div>
                </div>

                <div
                    className="border-t border-gray-900 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
                    <p className="text-gray-600 text-xs">
                        © {new Date().getFullYear()} {BRAND.legal_entity.replace(/\.$/, '')}. All rights reserved.
                    </p>
                    <div className="flex items-center gap-2">
                        <div className="w-2 h-2 rounded-full bg-green-500 animate-pulse"></div>
                        <span className="text-gray-500 text-xs">Systems Operational</span>
                    </div>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
